import React, { useState, useEffect, useRef } from "react";
import Sidebar from '../../composant_reutilisable/sidebar';
import Navbar from "../../composant_reutilisable/navbar";
import useAuth from '../../composant_reutilisable/useAuth';
import { Link } from "react-router-dom";
import { createPortal } from "react-dom";
import { useLocation } from 'react-router-dom';
import TableauDynamique from "../../composant_reutilisable/tableau";
import { BsPeople } from "react-icons/bs";
import { Modal, Button } from "react-bootstrap";
import ModalComponent from "../../composant_reutilisable/composant_modal";
import { FaCogs, FaUndo, FaQuestionCircle, FaTrash, FaEnvelopeOpenText, FaSortAmountDown, FaSortAmountUp, FaEllipsisV, FaEdit, FaShareAlt, FaBan, FaCheck } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import Footer from "../../composant_reutilisable/footer";
import { BsGridFill, BsListUl } from "react-icons/bs";

const DemandesReexamen = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [menu, setMenu] = useState(null);
    const menuRef = useRef(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    const user_id = localStorage.getItem('userId');
    const [selectedDemande, setSelectedDemande] = useState(null);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [alertModal, setAlertModal] = useState({ message: '', type: '' });
    const [sortConfig, setSortConfig] = useState({ key: "date", direction: "descending" });
    const [filtreStatut, setFiltreStatut] = useState("tous");
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [showSuspendModal, setShowSuspendModal] = useState(false);
    const [showRetirerModal, setShowRetirerModal] = useState(false);
    const [selectedDemandeDetails, setSelectedDemandeDetails] = useState(null);
    const [demandes, setDemandes] = useState([
        {
            demande_id: 1,
            nom_evenement: "FestiChill 2025",
            demandeur: "Jean Dupont",
            contact: "jean.dupont@example.com",
            details: "Je pense que la suspension est injustifiée.",
            raison: "Contenu inapproprié",
            date: "2025-05-15T10:30:00Z",
            statut: "En attente",
            date_traitement: null,
            traite_par: null,
            hoster: "Organisateur FestiChill"
        },
        {
            demande_id: 2,
            nom_evenement: "Soirée Afrobeat",
            demandeur: "Fatou B.",
            contact: "fatou.b@example.com",
            details: "L'événement ne contient aucun contenu inapproprié.",
            raison: "Contenu inapproprié",
            date: "2025-05-10T14:45:00Z",
            statut: "En attente",
            date_traitement: null,
            traite_par: "",
            hoster: "Club Afro Vibes"
        },
        {
            demande_id: 3,
            nom_evenement: "Concert Rock",
            demandeur: "Marc L.",
            contact: "marc.l@example.com",
            details: "La raison de la suspension n'est pas claire.",
            raison: "Contenu inapproprié",
            date: "2025-05-05T09:15:00Z",
            statut: "Restauré",
            date_traitement: "2025-05-08T11:20:00Z",
            traite_par: "Rozendo fernando",
            hoster: "Rock Nation"
        },
        {
            demande_id: 4,
            nom_evenement: "Festival Jazz",
            demandeur: "Sophie M.",
            contact: "sophie.m@example.com",
            details: "Nous avons corrigé les problèmes signalés.",
            raison: "Problème technique",
            date: "2025-04-28T16:30:00Z",
            statut: "Rejeté",
            date_traitement: "2025-05-02T10:10:00Z",
            traite_par: "Rozendo fernando",
            hoster: "Jazz Association"
        }
    ]);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(16);
    const [demandeSelectionnee, setGroupeSelectionne] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [displayMode, setDisplayMode] = useState("list");
    const [activeModal, setActiveModal] = useState(null); // 'detail', 'suspend', 'retirer'


    useEffect(() => {
        if (user_id) {
            document.title = "Showtime | Liste des demandes de réexamen";
        }
    }, [user_id]);

    const [showModal, setShowModal] = useState(false);

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 5000);
    };

    const showAlertModal = (message, type = 'success') => {
        setAlertModal({ message, type });
        setTimeout(() => {
            setAlertModal({ message: '', type: '' });
        }, 5000);
    };

    const location = useLocation();
    const evenement_id = location.state?.evenement_id;
    const evenement_nom = location.state?.evenement_nom;
    const traitement_id = location.state?.traitement_id;
    const isTraitement = location.state?.isTraitement;


    const fetchDemandes = async () => {
        try {
            setIsLoading(true);
            let url;

            if (isTraitement) {
                url = `${process.env.REACT_APP_HOTE}/demandes-par-traitement/${traitement_id}/`;
            } else {
                url = `${process.env.REACT_APP_HOTE}/liste-demandes/${evenement_id}/`;
            }

            const response = await fetch(url);

            if (!response.ok) {
                throw new Error(`Erreur serveur: ${response.status}`);
            }

            const data = await response.json();
            console.log("Demandes récupérées :", data);
            setDemandes(data);
        } catch (error) {
            console.error("Erreur lors du chargement des demandes :", error);
            showAlert("Une erreur est survenue lors du chargement des demandes", "danger");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (evenement_id || traitement_id) {
            fetchDemandes();
        }
    }, [evenement_id, traitement_id]);

    const demandesFiltrees = demandes.filter(demande =>
        demande?.nom_evenement?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        demande?.details?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        demande?.raison?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        demande?.date?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        demande?.demandeur?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const sortedDemandes = [...demandesFiltrees].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === "ascending" ? -1 : 1;
        if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === "ascending" ? 1 : -1;
        return 0;
    });

    const totalItems = demandesFiltrees.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfLastDemande = currentPage * itemsPerPage;
    const indexOfFirstDemande = indexOfLastDemande - itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentDemandes = sortedDemandes.slice(indexOfFirstDemande, indexOfLastDemande);
    const demandesAffichees = demandesFiltrees.slice(indexOfFirstItem, indexOfLastItem);

    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    const handleClick = (event, demande) => {
        event.stopPropagation();

        if (menu?.demande?.id === demande.id) {
            setMenu(null);
            return;
        }

        const buttonRect = event.currentTarget.getBoundingClientRect();

        setMenu({
            demande,
            x: buttonRect.left + window.scrollX,
            y: buttonRect.bottom + window.scrollY,
        });
    };

    const closeMenu = () => setMenu(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            const isActionButton = event.target.closest(".action-button");
            if (
                menuRef.current &&
                !menuRef.current.contains(event.target) &&
                !isActionButton
            ) {
                closeMenu();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [menu]);

    const handleSort = (key) => {
        setSortConfig({
            key,
            direction: sortConfig.key === key && sortConfig.direction === "ascending" ? "descending" : "ascending"
        });
    };

    const handleShowDeleteModal = (demandeSelectionnee) => {
        setGroupeSelectionne(demandeSelectionnee);
        if (!demandeSelectionnee) return;
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
    };

    const colonnesdropdown = [
        {
            label: "Retirer",
            icon: <FaCogs color="blue" />,
            actionKey: "retirer",
        },
        {
            label: "Suspendre",
            icon: <FaTrash color="red" />,
            actionKey: "suspendre",
        },
    ];

    const menuStyle = {
        position: "absolute",
        backgroundColor: "white",
        boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
        borderRadius: "4px",
        zIndex: 1000,
        minWidth: "150px",
        border: "1px solid #ddd",
        padding: "5px 0",
        right: "auto",
        left: 0,
    };

    const menuItemStyle = {
        padding: "8px 16px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        ":hover": {
            backgroundColor: "#f5f5f5",
        },
    };

    const MenuItem = ({ icon, color, label, onClick }) => (
        <li className="context-menu-item" onClick={onClick}>
            <span className="context-menu-icon" style={{ color }}>
                {icon}
            </span>
            <span>{label}</span>
        </li>
    );

    const handleDeleteEvenement = async () => {
        // Fonction à implémenter
    };

    const handleDemandeClick = (demande) => {
        setSelectedDemandeDetails({
            nom_evenement: demande.nom_evenement,
            hoster: demande.hoster,
            demandeur: demande.demandeur,
            details: demande.details,
            raison: demande.raison,
            date: demande.date,
            demande_id: demande.demande_id
        });
        setActiveModal('detail');
    };

    const handleSuspendModal = () => {
        setActiveModal('suspend');
    };

    const handleRetirerModal = () => {
        setActiveModal('retirer');
    };

    const closeModal = () => {
        setActiveModal(null);
    };

    const [filtresActifs, setFiltresActifs] = useState(false);

    const handleStartDateChange = (e) => {
        setStartDate(e.target.value);
        setFiltresActifs(e.target.value !== "" || endDate !== "");
    };

    const handleEndDateChange = (e) => {
        setEndDate(e.target.value);
        setFiltresActifs(startDate !== "" || e.target.value !== "");
    };

    const reinitialiserFiltres = () => {
        setStartDate("");
        setEndDate("");
        setFiltresActifs(false);
    };

    const handleSuspendEvent = async () => {
        if (!selectedDemandeDetails?.demande_id) {
            showAlert("Aucune demande sélectionnée", "danger");
            return;
        }

        try {
            setIsLoading(true);
            const response = await fetch(`${process.env.REACT_APP_HOTE}/suspendre-evenement/${selectedDemandeDetails.demande_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({
                    user_id: user_id  // Envoyez l'ID utilisateur dans le body si nécessaire
                })
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Erreur lors de la suspension');
            }

            const data = await response.json();
            showAlert(data.message || "Événement suspendu avec succès", "success");
            fetchDemandes(); // Rafraîchir la liste
            closeModal();
        } catch (error) {
            console.error("Erreur:", error);
            showAlert(error.message || "Erreur lors de la suspension", "danger");
        } finally {
            setIsLoading(false);
        }
    };

    const handleRestoreEvent = async () => {
        if (!selectedDemandeDetails?.demande_id) {
            showAlert("Aucune demande sélectionnée", "danger");
            return;
        }

        try {
            setIsLoading(true);
            const response = await fetch(`${process.env.REACT_APP_HOTE}/restaurer-evenement/${selectedDemandeDetails.demande_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({
                    user_id: user_id  // Envoyez l'ID utilisateur dans le body si nécessaire
                })
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Erreur lors de la restauration');
            }

            const data = await response.json();
            showAlert(data.message || "Événement restauré avec succès", "success");
            fetchDemandes(); // Rafraîchir la liste
            closeModal();
        } catch (error) {
            console.error("Erreur:", error);
            showAlert(error.message || "Erreur lors de la restauration", "danger");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <FaEnvelopeOpenText size={25} className='mr-2' />Gestion des appels
                                </div>
                            </h2>
                            <small id='hbreadcrumb' className='d-flex justify-content-between align-items-center'>
                                <span>Gestion des appels</span>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item active">
                                        Appels
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`mt-3 alert alert-${alert.type}`}>
                            {alert.message}
                        </div>
                    )}
                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5>Liste des appels</h5>

                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content">
                                        <div className="d-flex justify-content-between align-items-center mb-3" style={{ gap: "10px" }}>
                                            <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                                                <select
                                                    id="itemsPerPage"
                                                    value={itemsPerPage}
                                                    onChange={(e) => {
                                                        setItemsPerPage(Number(e.target.value));
                                                        setCurrentPage(1);
                                                    }}
                                                    className="form-select bg-default p-1"
                                                    style={{
                                                        width: "auto",
                                                        border: "1px black solid",
                                                        borderRadius: "5px",
                                                    }}
                                                >
                                                    <option value={12}>12</option>
                                                    <option value={22}>22</option>
                                                    <option value={50}>50</option>
                                                </select>
                                                <div className="d-flex justify-content-center flex-grow-1">
                                                    <div className="d-flex " style={{ gap: "10px" }}>
                                                        <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                                                            <label htmlFor="startDate" className="mb-0">Du:</label>
                                                            <input
                                                                type="date"
                                                                id="startDate"
                                                                className="form-control"
                                                                style={{ maxWidth: "150px", borderRadius: "5px" }}
                                                                value={startDate}
                                                                onChange={handleStartDateChange}
                                                            />
                                                        </div>
                                                        <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                                                            <label htmlFor="endDate" className="mb-0">Au:</label>
                                                            <input
                                                                type="date"
                                                                id="endDate"
                                                                className="form-control"
                                                                style={{ maxWidth: "150px", borderRadius: "5px" }}
                                                                value={endDate}
                                                                onChange={handleEndDateChange}
                                                                min={startDate}
                                                            />
                                                        </div>
                                                        {filtresActifs && (
                                                            <button
                                                                className="btn btn-secondary py-1"
                                                                onClick={reinitialiserFiltres}
                                                            >
                                                                Réinitialiser
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                                                <input
                                                    type="text"
                                                    placeholder="Rechercher..."
                                                    className="form-control"
                                                    style={{ width: "250px", borderRadius: "5px" }}
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                                {displayMode === "grid" && (
                                                    <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                                                        <span className="text-muted">Trier par :</span>
                                                        <select
                                                            className="form-select bg-default p-1"
                                                            value={sortConfig.key}
                                                            onChange={(e) => handleSort(e.target.value)}
                                                            style={{
                                                                width: "auto",
                                                                border: "1px black solid",
                                                                borderRadius: "5px",
                                                            }}
                                                        >
                                                            <option value="date">Date (récent → ancien)</option>
                                                            <option value="statut">Statut</option>
                                                            <option value="nom_evenement">Événement (A-Z)</option>
                                                            <option value="demandeur">Demandeur (A-Z)</option>
                                                        </select>

                                                        <button
                                                            className="btn btn-sm btn-light"
                                                            onClick={() => setSortConfig({
                                                                ...sortConfig,
                                                                direction: sortConfig.direction === "ascending" ? "descending" : "ascending"
                                                            })}
                                                        >
                                                            {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </button>
                                                    </div>
                                                )}
                                                <div className="btn-group">
                                                    <button
                                                        className={`btn btn-sm ${displayMode === 'list' ? 'btn-success' : 'btn-light'}`}
                                                        onClick={() => setDisplayMode('list')}
                                                        title="Vue liste"
                                                    >
                                                        <BsListUl />
                                                    </button>
                                                    <button
                                                        className={`btn btn-sm ${displayMode === 'grid' ? 'btn-success' : 'btn-light'}`}
                                                        onClick={() => setDisplayMode('grid')}
                                                        title="Vue grille"
                                                    >
                                                        <BsGridFill />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="table-responsive" style={{ overflowX: 'hidden' }}>
                                            {displayMode === "grid" ? (
                                                <div className="row">
                                                    {currentDemandes && currentDemandes.length > 0 ? (
                                                        currentDemandes.map((demande) => (
                                                            <div className="col-md-3 mb-4" key={demande.demande_id}>
                                                                <div
                                                                    className={`demande-card p-3 shadow-sm bg-white rounded border ${selectedDemande?.demande_id === demande.demande_id ? "border-primary" : "border-light"}`}
                                                                    onClick={() => handleDemandeClick(demande)}
                                                                    style={{ cursor: 'pointer', transition: '0.3s ease', position: 'relative' }}
                                                                >
                                                                    {/* Ligne avec le nom à gauche et le statut à droite */}
                                                                    <div className="d-flex justify-content-between align-items-start mb-2">
                                                                        <h5 className="text-primary font-weight-bold m-0">{demande.demandeur}</h5>
                                                                        <span
                                                                            className={`badge ${demande.statut === 'Restauré' ? 'bg-success' :
                                                                                demande.statut === 'Rejeté' ? 'bg-danger' :
                                                                                    demande.statut === 'En attente' ? 'bg-warning' : 'bg-secondary'
                                                                                }`}
                                                                            style={{ fontSize: '0.5rem' }}
                                                                        >
                                                                            {demande.statut}
                                                                        </span>
                                                                    </div>

                                                                    {/* Infos contact et date */}
                                                                    <div className="d-flex justify-content-between align-items-center">
                                                                        <div>
                                                                            <span className="text-muted small">Evènement :</span><br />
                                                                            <span className="font-weight-semibold">{demande.nom_evenement}</span>
                                                                        </div>
                                                                        <div className="text-end">
                                                                            <span className="text-muted small">Demandé le</span><br />
                                                                            <span className="text-dark small">{new Date(demande.date).toLocaleDateString()}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <div className="col-12 text-center py-4">
                                                            <span className="text-muted">Aucune demande trouvée</span>
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                <table className="footable table table-stripped footable-loaded tablet breakpoint"
                                                    data-page-size="8" data-filter="#filter" style={{ fontSize: "12px" }}>
                                                    <thead>
                                                        <tr>
                                                            <th className="text-secondary text-wrap d-none d-md-table-cell"
                                                                onClick={() => handleSort("date")}
                                                                style={{ width: "8%", minWidth: "100px" }}>
                                                                Date demande {sortConfig.key === "date"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className="text-secondary text-wrap d-none d-md-table-cell"
                                                                onClick={() => handleSort("demandeur")}
                                                                style={{ width: "8%", minWidth: "100px" }}>
                                                                Demandé par {sortConfig.key === "demandeur"}
                                                                {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className="text-secondary text-wrap d-none d-md-table-cell"
                                                                onClick={() => handleSort("nom_evenement")}
                                                                style={{ width: "5%", minWidth: "50px" }}>
                                                                Evenement {sortConfig.key === "nom_evenement"}
                                                                {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className="text-secondary text-wrap text-center d-none d-md-table-cell align-middle"
                                                                onClick={() => handleSort("raison")}
                                                                style={{ width: "8%", minWidth: "50px" }}>
                                                                Statut {sortConfig.key === "raison"}
                                                                {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className="text-secondary text-wrap d-none d-md-table-cell"
                                                                onClick={() => handleSort("date_traitement")}
                                                                style={{ width: "8%", minWidth: "100px" }}>
                                                                Date traitement {sortConfig.key === "date_traitement"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className="text-secondary text-wrap d-none d-md-table-cell"
                                                                onClick={() => handleSort("traite_par")}
                                                                style={{ width: "5%", minWidth: "100px" }}>
                                                                Traité par {sortConfig.key === "traite_par"}
                                                                {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {currentDemandes && currentDemandes.length > 0 ? (
                                                            currentDemandes.map((demande) => (
                                                                <tr key={demande.demande_id}
                                                                    onClick={() => handleDemandeClick(demande)}
                                                                    style={{ cursor: 'pointer' }}>
                                                                    <td className="d-none d-md-table-cell align-middle" style={{ padding: "0.5rem" }}>
                                                                        <span>{new Date(demande.date).toLocaleDateString()}</span>
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell align-middle" style={{ padding: "0.5rem" }}>
                                                                        <span>{demande.demandeur}</span>
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell align-middle" style={{ padding: "0.5rem" }}>
                                                                        <span>{demande.nom_evenement}</span>
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell text-center align-middle" style={{ padding: "0.5rem" }}>
                                                                        <span className={`badge ${demande.statut === 'Restauré' ? 'bg-success' :
                                                                            demande.statut === 'Rejeté' ? 'bg-danger' :
                                                                                demande.statut === 'En attente' ? 'bg-warning' : 'bg-secondary'
                                                                            }`}>
                                                                            {demande.statut}
                                                                        </span>
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell align-middle" style={{ padding: "0.5rem" }}>
                                                                        <span className="fw-semibold">{demande.date_traitement ? new Date(demande.date_traitement).toLocaleDateString() : ''}</span>
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell align-middle" style={{ padding: "0.5rem" }}>
                                                                        <span>{demande.traite_par}</span>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="3" className="text-center">
                                                                    Aucune demande trouvée
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            )}
                                        </div>

                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            <div className="dataTables_info" role="status" aria-live="polite">
                                                {totalItems === 0
                                                    ? "Aucun élément à afficher"
                                                    : `Élément ${currentPage === 1
                                                        ? 1
                                                        : (currentPage - 1) * itemsPerPage + 1
                                                    } à ${currentPage * itemsPerPage > totalItems
                                                        ? totalItems
                                                        : currentPage * itemsPerPage
                                                    } sur ${totalItems}`}
                                            </div>
                                            <div>
                                                {Array.from({ length: totalPages }, (_, index) => (
                                                    <button
                                                        key={index + 1}
                                                        onClick={() => setCurrentPage(index + 1)}
                                                        className={`btn ${currentPage === index + 1
                                                            ? "btn-default"
                                                            : "btn-light"
                                                            } mx-1`}
                                                    >
                                                        {index + 1}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="footer text-center">
                        <Footer />
                    </div>
                </div>
            </div>

            <Modal
                show={activeModal === 'detail'}
                onHide={closeModal}
                centered
                backdrop={true}
            >
                <Modal.Header className="border-1 rounded-top">
                    <Modal.Title className="font-bold">Détails de la demande</Modal.Title>
                </Modal.Header>
                <Modal.Body className="pt-3">
                    <div className="mb-4 p-3 bg-light rounded">
                        <div className="item d-flex justify-content-between mb-2">
                            <span className="item-label font-weight-bold">Nom évènement :</span>
                            <span className="item-value">{selectedDemandeDetails?.nom_evenement || "Non spécifié"}</span>
                        </div>
                        <div className="item d-flex justify-content-between mb-2">
                            <span className="item-label font-weight-bold">Hoster :</span>
                            <span className="item-value">{selectedDemandeDetails?.hoster || "Non spécifié"}</span>
                        </div>
                        <div className="item d-flex justify-content-between mb-2">
                            <span className="item-label font-weight-bold">Date de la demande :</span>
                            <span className="item-value">{new Date(selectedDemandeDetails?.date).toLocaleDateString() || "Non spécifié"}</span>
                        </div>
                        <div className="item d-flex justify-content-between mb-2">
                            <span className="item-label font-weight-bold">Demandé par :</span>
                            <span className="item-value">{selectedDemandeDetails?.demandeur || "Non spécifié"}</span>
                        </div>
                    </div>

                    <div className="form-group mt-4">
                        <label className="h5 mb-3">Commentaire:</label>
                        <div className="p-3 bg-light rounded" style={{ minHeight: '150px' }}>
                            {selectedDemandeDetails?.details || "Non spécifié"}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-top-0  justify-content-center" style={{ marginTop: "-30px", paddingBottom: "30px" }}>
                    {/* <button className="btn btn-secondary py-1" onClick={() => setShowDetailModal(false)}>
                        Fermer
                    </button> */}
                    <button className="btn btn-primary mr-5 py-1 d-inline-flex align-items-center" onClick={handleRetirerModal}>
                        <FaUndo className="mr-1" style={{ verticalAlign: 'middle' }} /> Restaurer
                    </button>
                    <button
                        className="btn btn-danger py-1 d-inline-flex align-items-center"
                        onClick={handleSuspendModal}
                    >
                        <FaBan className="mr-1" style={{ verticalAlign: 'middle' }} />
                        Bloquer
                    </button>
                </Modal.Footer>
            </Modal>

            <Modal
                show={activeModal === 'retirer'}
                onHide={closeModal}
                centered
                size="sm"
                backdrop={true}
                style={{ fontSize: "11px" }}>
                <Modal.Body className="text-center">
                    <FaUndo className="text-restaure mb-3" size={60} style={{ marginTop: "-15px" }} />
                    <p>Êtes-vous sûr de vouloir restaurer cet évènement ?</p>
                </Modal.Body>

                <Modal.Footer className="border-top-0 flex-column align-items-center" style={{ marginTop: "-40px" }}>
                    <div className="d-flex justify-content-center mb-2">
                        <Button variant="secondary" className="mr-5 px-4" onClick={() => setActiveModal('detail')}>
                            Non
                        </Button>
                        <Button variant="primary" className="px-4" onClick={() => {
                            handleRestoreEvent();
                            setShowRetirerModal(false);
                            showAlert("L'événement a été retiré avec succès", "success");
                        }}>
                            Oui
                        </Button>
                    </div>
                    <small className="text-muted text-center mb-3">
                        Cet événement sera remis en fil d'actualité.
                    </small>
                </Modal.Footer>
            </Modal>

            <Modal
                show={activeModal === 'suspend'}
                onHide={closeModal}
                centered
                size="sm"
                backdrop={true}
                style={{ fontSize: "11px" }}>
                <Modal.Body className="text-center">
                    <FaBan className="text-danger mb-3" size={60} style={{ marginTop: "-15px" }} />
                    <p>Êtes-vous sûr de vouloir suspendre cet évènement ?</p>
                </Modal.Body>

                <Modal.Footer className="border-top-0 flex-column align-items-center" style={{ marginTop: "-40px" }}>
                    <div className="d-flex justify-content-center mb-2">
                        <Button variant="secondary" className="mr-5 px-4" onClick={() => setActiveModal('detail')}>
                            Non
                        </Button>
                        <Button variant="danger" className="px-4" onClick={() => {
                            handleSuspendEvent();
                            setShowSuspendModal(false);
                            showAlert("L'événement a été suspendu avec succès", "success");
                        }}>
                            Oui
                        </Button>
                    </div>
                    <small className="text-muted text-center mb-3">
                        Cette action est irréversible et empêchera tout accès à l'événement.
                    </small>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default DemandesReexamen;